import { render } from "./MaterialCatalog.vue?vue&type=template&id=41fe6c7f&scoped=true"
import script from "./MaterialCatalog.vue?vue&type=script&lang=js"
export * from "./MaterialCatalog.vue?vue&type=script&lang=js"

import "./MaterialCatalog.vue?vue&type=style&index=0&id=41fe6c7f&lang=less&scoped=true"
import "./MaterialCatalog.vue?vue&type=style&index=1&id=41fe6c7f&lang=less&scoped=true"
import "./MaterialCatalog.vue?vue&type=style&index=2&id=41fe6c7f&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41fe6c7f"]])

export default __exports__